import { useMutation } from '@tanstack/react-query';
import { gerarRelatorioPdfLoteApi } from '../api/GerarRelatorioPDFLoteApi';
import type { GerarRelatorioPDFLotePayload, GerarRelatorioPDFLoteResponse } from '../types';

export function useGerarRelatorioPDFLote() {
  return useMutation<GerarRelatorioPDFLoteResponse, Error, GerarRelatorioPDFLotePayload>({
    mutationFn: gerarRelatorioPdfLoteApi,
  });
}
